import React, { useState } from "react";
import InfiniteScrollContainer from "../../../../components/InfiniteScroll/InfiniteScroll";
import CustomCard from "../../../../components/Card";
import CustomChip from "../../../../components/Chip";
import moment from "moment";
import BaseToggle from "./BaseToggle";
import CustomButton from "../../../../components/AddButton";
import { document, Plus } from "../../../../common/svg";
import SecureImage from "../../../../components/BucketImage/Image";
import CircularProgress from "../../../../components/DaysProgress";
import ContainerStatus from "./ContainerStatus";
import SurveyorDetails from "./SurveyorDetails";
import CargoDetails from "./CargoDetails";
import DocumentUpload from "../components/Upload";
interface cargoDetailsProps {
  cargo: any;
  setContainer: React.Dispatch<React.SetStateAction<any>>;
}

const ContainerDetails: React.FC<cargoDetailsProps> = ({
  cargo,
  setContainer,
}) => {
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [activeCardIndex, setActiveCardIndex] = useState<number | null>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const handleViewBookingDetails = (index: number, item: any) => {
    setActiveCardIndex(index);
    setSelectedItem(item);
  };

  const fetchMoreData = async () => {
    if (!hasMore || isFetching) return;

    setIsFetching(true);

    // Implement your API call logic here
    // ...

    setIsFetching(false);
  };

  return (
    <div className="flex flex-row w-full gap-4">
      {/* Left side - Cards list */}
      <div className="w-[400px] flex-shrink-0">
        <InfiniteScrollContainer
          width="100%"
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          isFetching={isFetching}
        >
          <div className="flex flex-col">
            {cargo?.map((item: any, index: number) => (
              <CustomCard
                key={index}
                onClick={() => handleViewBookingDetails(index, item)}
                isActive={activeCardIndex === index}
                className="w-full shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded"
              >
                <div className="gap-[-1]">
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2 w-fit">
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold truncate" title={item.id}>
                          {item.id}
                        </p>
                      </div>
                      <CustomChip
                        text={
                          item.bookingStatus
                            ? item.bookingStatus
                            : "Not Assigned"
                        }
                        textColor="#FF973C"
                        borderColor="#FF973C"
                        className="flex-shrink-0"
                      />
                    </div>

                    <p className="font-[400] text-[14px]">#0{index + 1}</p>
                  </div>
                  <div className="flex justify-between">
                    <div className="leading-[18px]">
                      <p className="text-[14px]">{item.task}</p>
                      <p className="text-[14px]">
                        {moment(item.date).format("DD MMMM YYYY, hh:mma")}
                      </p>
                    </div>
                    <div className="flex items-center flex-col justify-center">
                      <p className="text-[14px] font-[400]">Total Trip</p>
                    </div>
                  </div>
                  <div className="flex justify-between items-end">
                    <div className="flex flex-col leading-[15px]">
                      <p className="text-[14px]">Container No</p>
                      <button
                        className={`font-medium text-[14px] ${activeCardIndex === index
                          ? ""
                          : ""
                          }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          console.log("Client clicked");
                        }}
                      >
                        {item.clientFirstName
                          ? item.clientFirstName
                          : "CMA 87574867658768"}
                      </button>
                    </div>
                    <p className="text-[14px] font-[600]">
                      {item.localStorage}
                    </p>
                  </div>
                </div>
              </CustomCard>
            ))}
          </div>
        </InfiniteScrollContainer>
      </div>

      {/* Right side - Selected card details */}
      <div className="flex-grow border-l-2 border-dashed p-4 overflow-hidden">
        <div className="flex justify-between items-center p-2 flex-wrap">
          <div className="leading-[15px] flex-1 min-w-0">
            <div
              className="flex items-center space-x-2"
              title=""
              style={{ cursor: "pointer" }}
            // onClick={() => navigate("view")}
            >
              <SecureImage fileKey={document} alt="header icon" width="60px" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 leading-[-15px]">
                  <p className="text-[#444FBD] text-[14px]  font-[600]">
                    CMA 8768787679799
                  </p>
                  <CustomChip
                    text="Waiting for clearance"
                    textColor="#FF973C"
                    backgroundColor="#FFF5EC"
                    borderColor="#FF973C"
                  />
                </div>
                <p className="text-[14px]  font-[400]">Empty to Warehouse</p>
                <p className="text-[14px]  font-[400]">30 July 2024, 06:16pm</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-end">
            <div className="flex items-center">
              <CircularProgress totalDays={5} />
              <p className="text-[14px] font-[400]">Days left</p>
            </div>
            <p className="text-[14px]">30 July 2024, 06:16pm</p>
          </div>
        </div>
        <br />
        <BaseToggle />
        <br />
        <br />
        <ContainerStatus />
        <br />
        {/* <SurveyorDetails /> */}
        <div className="border-b border-[#C1C1C1] border-dashed"></div>
        <DocumentUpload />
        <br />
        {/* <ContainerDetails /> */}
      </div>
    </div>
  );
};

export default ContainerDetails; 